import type { AccountDto } from "../../../shared/types";
import type { ActiveTab } from "../../App";
import { AccountCard } from "./AccountCard";
import { DashboardHero } from "./DashboardHero";
import { OverallMailStats } from "./MailStats";
import { AddAccountButton } from "../layout/AddAccountButton";
import { useMailStats } from "../../hooks/useApi";

export function DashboardTab({
  accounts,
  onOpen,
}: {
  accounts: AccountDto[];
  onOpen: (tab: ActiveTab) => void;
}) {
  const { data: mailStats } = useMailStats();
  return (
    <div className="h-full overflow-y-auto p-6">
      <DashboardHero />
      {mailStats && <OverallMailStats stats={mailStats} />}
      <h2 className="pb-1 text-[17px] font-semibold">Accounts</h2>
      <p className="pb-5 text-[13px] text-ink-muted">
        {accounts.length === 0
          ? "No accounts connected yet — add your first one."
          : `${accounts.length} connected account${accounts.length === 1 ? "" : "s"}.`}
      </p>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
        {accounts.map((account) => (
          <AccountCard
            key={account.id}
            account={account}
            mailStats={mailStats?.accounts.find((a) => a.accountId === account.id)}
            onOpen={() => onOpen(account.id)}
          />
        ))}
        <AddAccountButton variant="card" />
      </div>
    </div>
  );
}
